import { spaceSelectorButtonSx, listMenuItemSx } from 'components/styles/menu';
import { limitedSpanSx } from 'components/styles/span';
import { Button, ListItemButton, Menu, ListItemText, Box } from 'components/ui';
import {
  ArrowDropDownIcon,
  ArrowDropUpIcon,
  CheckIcon,
  AddIcon,
  ProbelistWorkspaceSwitchIcon,
} from 'components/uiIcons';
import { useSpace } from 'contexts/space';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DashboardLink, SpacesLink, hardRedirect } from 'utils/link';
import useResourceShow from 'hooks/use_resource_show';
import SpacesQuery from 'queries/space';

const SpaceSelector = ({ currentName }) => {
  const intl = useIntl();
  const { currentSpaceId, selectSpace, clearSpace } = useSpace();
  const [spaceAnchorEl, setSpaceAnchorEl] = useState(null);
  const spaceOpen = Boolean(spaceAnchorEl);

  const { data } = useResourceShow({
    query: SpacesQuery,
    fetchPolicy: 'cache-first',
    defaultData: { spaces: { spaces: [] }, invitedSpaces: { spacesTotal: 0 }, user: { canAddSpace: false } },
  });
  const spaces = data.spaces?.spaces ?? [];

  const handleSpaceClick = (event) => {
    setSpaceAnchorEl(event.currentTarget);
  };

  const handleSpaceClose = () => {
    setSpaceAnchorEl(null);
  };

  const onSpaceItemClick = (id) => {
    if (id === currentSpaceId) {
      handleSpaceClose();
      return;
    }
    selectSpace(id);
    hardRedirect(DashboardLink());
  };

  const onManageClick = () => {
    clearSpace();
    hardRedirect(SpacesLink());
  };

  const icon = spaceOpen ? (
    <ArrowDropUpIcon aria-hidden="true" />
  ) : (
    <ArrowDropDownIcon aria-hidden="true" />
  );

  return (
    <>
      <Button sx={spaceSelectorButtonSx}
        aria-label={intl.formatMessage({ id: 'navbar.space' })}
        aria-haspopup="menu"
        aria-expanded={spaceOpen}
        aria-controls={spaceOpen ? 'space-selector-menu' : undefined}
        onClick={handleSpaceClick}>
        <ProbelistWorkspaceSwitchIcon aria-hidden="true" sx={{ mr: 1 }} /><Box component="span" sx={limitedSpanSx}>{currentName}</Box> {icon}
      </Button>
      <Menu
        id="space-selector-menu"
        anchorEl={spaceAnchorEl}
        open={spaceOpen}
        onClose={handleSpaceClose}>
        {spaces.map((space) => {
          const isCurrent = space.id === currentSpaceId;
          return (
            <ListItemButton sx={listMenuItemSx}
              key={space.id}
              selected={isCurrent}
              onClick={() => onSpaceItemClick(space.id)}>
              {isCurrent ? (
                <CheckIcon aria-hidden="true" />
              ) : (
                <Box sx={{ width: 24 }} aria-hidden="true" />
              )}
              <ListItemText>{space.name}</ListItemText>
            </ListItemButton>
          );
        })}
        {data.invitedSpaces?.spacesTotal> 0 && (
          <ListItemButton sx={listMenuItemSx} onClick={onManageClick}>
            <AddIcon aria-hidden="true" />
            <ListItemText>
              <FormattedMessage id="spaces.invitations.title" />
            </ListItemText>
          </ListItemButton>
        )}
        {data.user?.canAddSpace && (
          <ListItemButton sx={listMenuItemSx} onClick={onManageClick}>
            <AddIcon aria-hidden="true" />
            <ListItemText>
              <FormattedMessage id="button.create_workspace" />
            </ListItemText>
          </ListItemButton>
        )}
      </Menu>
    </>
  );
};

export default SpaceSelector;
